export type VideoQuantity = {
  sdSingle?: number;
  hdSingle?: number;
  sdAbr?: number;
  hdAbr?: number;
  mode: string[];
};

export enum Mode {
  Transcoding = 'transcoding',
  Packaging = 'packaging',
}
